<!--
 * @Description: 教师教学考核 考核项目 评价
 * @Author: PF
 * @Date: 2025-03-27 10:43:36
 * @LastEditors: PF
 * @LastEditTime: 2025-03-28 16:03:35
-->
<template>
  <div>
    <el-dialog class="w800 h600" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">评价</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="0">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="评价内容" label-align="right" align="left" width="100px" span="2">{{khnrData.khxmnr}}</el-descriptions-item>
          <el-descriptions-item label="评价指标" label-align="right" align="left" width="100px" span="2">
            <p v-for="(item, index) in khnrData.listZb" :key="index">{{ item.khzb }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="评分选项" label-align="right" align="left" width="100px" span="2">
            <el-form-item v-if="pffs===1" label="" prop="dfxx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-radio-group v-model="ruleForm.dfxx">
                <el-radio v-for="(item, index) in pfxxData" :key="index" :label="item.pfx" size="large">{{item.pfx}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-else label="" prop="zdf" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.zdf" :min="0" />
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item label="考核人" label-align="right" align="left" width="100px" span="2">{{khnrData.khrmc}}</el-descriptions-item>
          <el-descriptions-item label="评价人" label-align="right" align="left" width="100px" span="2">{{khnrData.pjrmc}}</el-descriptions-item>
        </el-descriptions>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" :loading="loading" @click="open()">保存</el-button>
            <el-button type="info" @click="closeWindow('openList', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  closeWindow,
  actionPost
} from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo'
import { ElNotification, ElMessageBox } from 'element-plus'
const props = defineProps({
  openList: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openList', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})
const loading = ref(false)
const khnrData = ref({}) // 考核内容
const pfxxData = ref([]) // 评分选项
const pffs = ref() // 评分方式：1-选项，2-公式

watch(
  () => props.openList,
  () => {
    if (props.openList) {
      khnrData.value = {}
      pfxxData.value = []
      loading.value = true
      ruleForm.value.menuId = sessionStorage.getItem('menuId')
      actionPost({
        url: `/api/v2/kaohexiangmu/kaohexiangmu/getkaoheneirong/pingfen/${props.row.id}`,
        data: {}
      }).then((res) => {
        loading.value = false
        if (res.code === 200) {
          khnrData.value = res.data.data
          ruleForm.value.id = res.data.data.id
          pfxxData.value = res.data.bz
          pffs.value = res.data.pffs
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

const open = () => {
  loading.value = true
  ElMessageBox.confirm('您确定要提交评价吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    loading.value = false
    submit()
  }).catch(() => {
    loading.value = false
  })
}
// 提交
const submit = async () => {
  let url = ''
  // 评分方式：1-选项，2-公式
  switch (pffs.value) {
    case 1:
      url = '/api/v2/kaohexiangmu/kaohexiangmu/xuanxiangpingfen'
      break
    case 2:
      url = '/api/v2/kaohexiangmu/kaohexiangmu/gongshipingfen'
      break
  }
  const forms = unref(ruleFormRef)
  if (!forms) return
  await forms.validate()
  loading.value = true
  actionPost({ url, data: ruleForm.value }).then((res) => {
    loading.value = false
    if (res.code === 200) {
      closeWindow('openList', emits, true)
      return ElNotification({
        title: '提示',
        message: res.message,
        type: 'success',
        position: 'bottom-right',
        duration: 3000
      })
    } else {
      return ElMessageBox.confirm(res.message, '警告',
        {
          showCancelButton: false,
          confirmButtonText: '关闭',
          type: 'warning'
        }
      )
    }
  })
}
</script>
